import script from "./SubscriptionsQuery.vue?vue&type=script&lang=js"
export * from "./SubscriptionsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__